module.exports = __webpack_public_path__ + "static/media/StarLeftSecondary.6603d316.svg";